import { render, staticRenderFns } from "./TextLinkListExpand.vue?vue&type=template&id=13c2fa32&scoped=true&"
import script from "./TextLinkListExpand.vue?vue&type=script&lang=js&"
export * from "./TextLinkListExpand.vue?vue&type=script&lang=js&"
import style0 from "./TextLinkListExpand.vue?vue&type=style&index=0&id=13c2fa32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c2fa32",
  null
  
)

export default component.exports